import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment';

import Modal from 'components/Modal';
import { CostAndChargesLink } from 'components/CostAndChargesLink';

import formatNumber from 'utils/formatNumber';

export default class ConfirmModal extends React.Component {
  static propTypes = {
    order: PropTypes.object.isRequired,
    handleConfirmSubmit: PropTypes.func.isRequired,
    open: PropTypes.bool,
    handleHideModal: PropTypes.func,
  };

  render() {
    const {
      order = {},
      transactionInTransit = false,
      handleHideModal,
      currency,
      errors,
    } = this.props;

    // const CommissionPercentage = () => {
    // Math.round((order.COMMISSION) / (order.ORDER_PRICE + order.COMMISSION));
    // };

    return (
      <Modal {...this.props}>
        <h2>Kjøp - bekreft</h2>
        <table>
          <tbody>
            <tr>
              <td className="text">
                <b>Selskap/ticker:</b>
              </td>
              <td>
                {order && `${order.TICKER_CODE} (${order.STOCK_EXCHANGE_ID})`}
              </td>
            </tr>
            <tr>
              <td className="text">
                <b>Antall:</b>
              </td>
              <td>{formatNumber(order.VOLUME, 0)}</td>
            </tr>
            <tr>
              <td className="text">
                <b>Limit:</b>
              </td>
              <td>
                {formatNumber(order.LIMIT, 2)} {currency}
              </td>
            </tr>
            {currency !== 'NOK' && (
              <tr>
                <td className="text">
                  <b>Estimert valutakurs:</b>
                </td>
                <td>
                  {formatNumber(order.CURRENCY_EXCHANGE_RATE, 4)} {currency}
                  /NOK
                </td>
              </tr>
            )}
            <tr>
              <td className="text">
                <b>Gyldighet:</b>
              </td>
              <td>
                {order &&
                  moment(order.EXPIRATION_DATE).format('DD.MM.YY HH:mm')}
              </td>
            </tr>
            <tr>
              <td className="text">
                <b>Kurtasje:</b>
              </td>
              <td>
                {formatNumber(order.COMMISSION, 2)} kr /{' '}
                {formatNumber(100 * (order.COMMISSION / order.ORDER_PRICE))}%
                NOK
              </td>
            </tr>
            <tr>
              <td className="text">
                <b>Estimert totalpris:</b>
              </td>
              <td>
                {formatNumber(order.ORDER_PRICE + order.COMMISSION)}
                {''}NOK
              </td>
            </tr>
            <tr>
              <td className="text">
                <CostAndChargesLink
                  itemSector={`${order.TICKER_CODE}.${order.STOCK_EXCHANGE_ID}`}
                />
              </td>
            </tr>
          </tbody>
        </table>
        <div className="buttons">
          <button className="cancel" onClick={handleHideModal}>
            Avbryt
          </button>
          <button
            onClick={e => this.props.handleConfirmSubmit(e)}
            disabled={transactionInTransit}
          >
            Bekreft
          </button>
        </div>
        {errors?.some(item => /coverage/g.test(item)) && (
          <span className="errorMessage">
            Du har ikke dekning på konto for å gjennomføre kjøpet.
          </span>
        )}
        {!!transactionInTransit && !errors && (
          <div className="spinner-wrapper">
            <i className="fa fa-spinner fa-spin" />
          </div>
        )}
      </Modal>
    );
  }
}
